module.exports = __webpack_public_path__ + "img/ALC068-1.5014c198.jpg";